import { Field } from '@chakra-ui/react';
import {
  FilterTypeGlte,
  RenderTableFilterOptionProps,
} from '@monetize/types/common';
import { parseISO } from 'date-fns/parseISO';
import { FunctionComponent as FC } from 'react';
import { MVStack } from '../../chakra';
import { DatePicker } from '../../DatePicker/DatePicker';

interface DateGlteTableFilterOptionContentProps extends RenderTableFilterOptionProps {
  showTimePicker?: boolean;
}

const DateGlteTableFilterOptionContent: FC<
  DateGlteTableFilterOptionContentProps
> = ({
  filter,
  filterOption,
  handleFilterChange,
  showTimePicker = false,
}: DateGlteTableFilterOptionContentProps) => {
  const internalFilter = filter as FilterTypeGlte;

  return (
    <MVStack>
      <Field.Root>
        <Field.Label>From</Field.Label>
        <DatePicker
          includeTime={showTimePicker}
          placeholder="From"
          onChange={(date) => {
            handleFilterChange(
              {
                ...internalFilter?.value,
                min: date!,
              },
              filterOption,
            );
          }}
          value={internalFilter?.value?.min}
          maxDate={
            internalFilter?.value?.max
              ? parseISO(internalFilter.value.max)
              : undefined
          }
          clearable
        />
      </Field.Root>
      <Field.Root>
        <Field.Label>To</Field.Label>
        <DatePicker
          includeTime={showTimePicker}
          placeholder="To"
          onChange={(date) => {
            handleFilterChange(
              {
                ...internalFilter?.value,
                max: date!,
              },
              filterOption,
            );
          }}
          value={internalFilter?.value?.max}
          minDate={
            internalFilter?.value?.min
              ? parseISO(internalFilter.value.min)
              : undefined
          }
          clearable
        />
      </Field.Root>
    </MVStack>
  );
};

export { DateGlteTableFilterOptionContent };
